// extracted by mini-css-extract-plugin
export var content = "gamification-businnes-partners-zone-module--content--V+1hg";
export var dropdown = "gamification-businnes-partners-zone-module--dropdown--ZwgfS";
export var linksWrapper = "gamification-businnes-partners-zone-module--links-wrapper--v+DVB";